import { objectValues } from '~/web-frontend-core/base/lib';
import { CONNECTION_STATE } from './socket/BaseSocket';
const IS_SERVER = typeof document === 'undefined';
const SEC = 1000;
export const CONNECTION_TIMEOUT_MS = 5 * SEC;
/**
 * @class
 * @static Все члены статик, потому что singleton, (должно быть только одно сокет подключение)
 * @abstract
 * Отвечает за работу с сокетами ({@link WebSocket}, {@link AxiosSocket}):
 *  - восстанавление соединения
 *  - подписка/отписка от сокета
 *  - сохранение обработчиков при пересоздании сокета
 */
export class BaseSocketListener {
    constructor() {
        throw new Error('Класс BaseSocketListener должен быть singleton, все методы статические, он не должен иметь экземпляров');
    }
    //#region API
    static subscribe(msg, handlers = {}, target) {
        this.handlers[msg.t] = handlers;
        this.internalHandlers.visibilitychange = () => {
            /**
             * На мобильных устройствах фоновые подключения часто закрываются
             * Если страница снова стала видимой и нет подключения, то немедленно переподписываемся
             */
            if (!IS_SERVER && !document.hidden && this.state !== CONNECTION_STATE.OPEN) {
                this.subscribe(msg, handlers);
            }
        };
        return this.send(JSON.stringify(msg), target).catch((e) => {
            this.removeHandlers();
            handlers.onerror && handlers.onerror(e);
        });
    }
    static unsubscribe(cfg, target) {
        if (this.state !== CONNECTION_STATE.OPEN) {
            return Promise.resolve();
        }
        return this.subscribe(cfg, {}, target).then(() => {
            //this.removeHandlers();
        });
    }
    //#endregion
    static get state() {
        if (!this.socket) {
            return CONNECTION_STATE.CLOSED;
        }
        return this.socket.readyState;
    }
    static createSocket() {
        throw new Error('Статический метод createSocket должен быть переопределен в дочерних классах');
    }
    static send(message, target) {
        this.messages.add(message);
        return this.restoreConnection().then(() => {
            if (this.state !== CONNECTION_STATE.OPEN) {
                throw new Error(`[${this}] Сокет не восстановил соединение`);
            }
            this.messages.forEach((m) => { var _a; (_a = this.socket) === null || _a === void 0 ? void 0 : _a.send(m, target); });
            this.messages.clear();
        });
    }
    static restoreConnection() {
        return new Promise((resolve, reject) => {
            try {
                // соединение без подписок закрывается через 10 сек
                if (!this.socket || this.state === CONNECTION_STATE.CLOSED) {
                    this.socket = this.createSocket();
                    if (/debug/.test(document.cookie)) {
                        window['debug:websocket'] = this.socket;
                    }
                }
                this.setHandlers(resolve, reject);
            }
            catch (e) {
                reject(e);
                return;
            }
            setTimeout(() => {
                if (this.state === CONNECTION_STATE.OPEN || this.state === CONNECTION_STATE.CLOSED) {
                    return;
                }
                reject(new Error(`[${this}] Истек timeout подключения`));
            }, CONNECTION_TIMEOUT_MS);
        });
    }
    static setHandlers(onopen, onerror) {
        var _a, _b;
        if (!IS_SERVER && this.internalHandlers.visibilitychange) {
            document.addEventListener('visibilitychange', this.internalHandlers.visibilitychange);
        }
        if (!this.socket) {
            return;
        }
        this.socket.onmessage = (msg) => {
            var _a;
            const data = JSON.parse(msg.data);
            const handlers = this.handlers[data.t];
            (_a = handlers === null || handlers === void 0 ? void 0 : handlers.onmessage) === null || _a === void 0 ? void 0 : _a.call(handlers, msg);
        };
        const forEachHandler = (f) => {
            objectValues(this.handlers).filter((f) => !!f).forEach(f);
        };
        this.socket.onclose = (closeEvent) => {
            const e = new CloseEvent(`${this}: Соединение закрыто: ${closeEvent}`);
            forEachHandler((handlers) => {
                var _a;
                (_a = handlers === null || handlers === void 0 ? void 0 : handlers.onclose) === null || _a === void 0 ? void 0 : _a.call(handlers, e);
            });
        };
        this.socket.onerror = (e) => {
            const error = new Event(`${this}: Ошибка соединения: ${JSON.stringify(e)}`);
            forEachHandler((handlers) => {
                var _a;
                (_a = handlers === null || handlers === void 0 ? void 0 : handlers.onerror) === null || _a === void 0 ? void 0 : _a.call(handlers, error);
            });
            onerror(error);
        };
        this.socket.onopen = () => {
            const event = new Event(`${this}: Соединение открыто`);
            forEachHandler((handlers) => {
                var _a;
                (_a = handlers === null || handlers === void 0 ? void 0 : handlers.onopen) === null || _a === void 0 ? void 0 : _a.call(handlers, event);
            });
            onopen();
        };
        this.state === CONNECTION_STATE.CLOSED && ((_b = (_a = this.socket).onclose) === null || _b === void 0 ? void 0 : _b.call(_a, new CloseEvent('')));
        this.state === CONNECTION_STATE.OPEN && this.socket.onopen(new Event(''));
    }
    static removeHandlers() {
        if (!IS_SERVER && this.internalHandlers.visibilitychange) {
            document.removeEventListener('visibilitychange', this.internalHandlers.visibilitychange);
        }
        if (!this.socket) {
            return;
        }
        // this.socket.onmessage = void 0;
        // this.socket.onclose = void 0;
        // this.socket.onerror = void 0;
        // this.socket.onopen = void 0;
    }
}
BaseSocketListener.handlers = {};
BaseSocketListener.internalHandlers = {};
BaseSocketListener.messages = new Set([]);
BaseSocketListener.socket = null;



// WEBPACK FOOTER //
// ./src/web-frontend-core/api/connector/socketListener/BaseSocketListener.js